import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  AssetsGetShareSchemaWithIdNullable,
  AssetsShareTokenSchema,
} from '@iconik-io/iconik-api/src/services/assets';

import { emptyUntilLoaded } from '../../store/empty_slice_state';
import type { ShareAppState, ShareViewer } from './types';

const initialState: ShareAppState = {
  shareAuthLoginError: [],
  share: emptyUntilLoaded<AssetsGetShareSchemaWithIdNullable>(),
  shareAuthLoading: false,
};

export const shareSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    shareAuthLogin: (state, action: PayloadAction<AssetsShareTokenSchema>) => {
      state.shareAuthLogin = action.payload;
    },
    shareAuthLoginLoading: (state, action: PayloadAction<boolean>) => {
      state.shareAuthLoading = action.payload;
    },
    shareGet: (
      state,
      action: PayloadAction<AssetsGetShareSchemaWithIdNullable>,
    ) => {
      state.share = action.payload;
    },
    shareSetShareLinkUserEmail: (state, action: PayloadAction<string>) => {
      state.shareLinkUserEmail = action.payload;
    },
    shareSetViewer: (state, action: PayloadAction<ShareViewer>) => {
      state.viewer = action.payload;
    },
  },
});

export const {
  shareAuthLogin,
  shareAuthLoginLoading,
  shareGet,
  shareSetShareLinkUserEmail,
  shareSetViewer,
} = shareSlice.actions;

export const shareReducer = shareSlice.reducer;
